import { useResponsive } from 'app/hooks';
import { Dialog, SVG, Text } from 'app/pages/request-single-page/components-v4';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';
import {
  HeaderWrapper,
  MobileHeader,
  MobileHeaderClose,
} from './modal-header.styled';

type ModalHeaderProps = {
  onClose: () => void;
};

export const ModalHeader = ({ onClose }: ModalHeaderProps) => {
  const { viewport } = useResponsive();

  return (
    <HeaderWrapper>
      {viewport.desktop ? (
        <Dialog.Title>Передача показаний</Dialog.Title>
      ) : (
        <MobileHeader onClick={onClose}>
          <MobileHeaderClose onClick={onClose}>
            <SVG src={Icons.Chevron} props={{ deg: 90 }} />
            <Text>Назад</Text>
          </MobileHeaderClose>

          <Dialog.Title align="center" style={{ flex: 1 }}>
            Передача показаний
          </Dialog.Title>
        </MobileHeader>
      )}
    </HeaderWrapper>
  );
};
